import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { TicketStatus, TicketType } from "../services/ticketService";

const STATUS_COLOR: Record<TicketStatus, "default" | "primary" | "success" | "warning" | "error" | "info"> = {
  OPEN: "info",
  ANALYZING: "info",
  ANALYZED: "primary",
  NEEDS_CLARIFICATION: "warning",
  SUPPORT_QUEUE: "warning",
  CONFLICT_REVIEW: "warning",
  AUTO_REJECTED: "error",
  REJECTED: "error",
  APPROVED_FOR_DEV: "primary",
  DEV_IN_PROGRESS: "info",
  DEV_READY: "success",
  DEV_FAILED: "error",
  MERGED: "success",
  LIVE: "success",
};

const TYPE_COLOR: Record<TicketType, "default" | "primary" | "success" | "warning" | "error" | "info"> = {
  SUPPORT: "info",
  FEATURE: "primary",
  CHANGE: "warning",
  BUG: "error",
};

export function StatusChip({ status }: { status: TicketStatus }) {
  const { t } = useTranslation();
  return <Chip size="small" color={STATUS_COLOR[status] || "default"} label={t(`status.${status}`)} />;
}

export function TypeChip({ type }: { type: TicketType }) {
  const { t } = useTranslation();
  return <Chip size="small" variant="outlined" color={TYPE_COLOR[type] || "default"} label={t(`types.${type}`)} />;
}
